import { render } from "./SeriesSelectorThankYou.vue?vue&type=template&id=5878551a"
import script from "./SeriesSelectorThankYou.vue?vue&type=script&lang=js"
export * from "./SeriesSelectorThankYou.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__